import React from "react";
import "./Location.css";

const Location = () => {
  return (
    <div className="locationcontainer">
      <div className="locationtitle">
        <div className="locationaddresstitle">Location</div>
        <div className="locationaddressvalue">
          2070 Buford Hwy, Suite 1B
          <br />
          Buford, GA 30518
        </div>
      </div>
      <iframe
        title="GoogleMap"
        className="locationmap "
        src="https://www.google.com/maps/embed?pb=!1m18!1m12!1m3!1d3308.202712623408!2d-84.00045294267018!3d34.109767140573304!2m3!1f0!2f0!3f0!3m2!1i1024!2i768!4f13.1!3m3!1m2!1s0x88f5938757a0dae9%3A0x9987e9a03ab16bbe!2sCounseling%20and%20Psychotherapy%20Associates%20of%20Georgia!5e0!3m2!1sen!2sus!4v1730323582099!5m2!1sen!2sus"
        // width="600"
        height="450"
        allowfullscreen=""
        loading="lazy"
        referrerpolicy="no-referrer-when-downgrade"
      ></iframe>
    </div>
  );
};

export default Location;
